import { useTranslation } from 'react-i18next';
import { ToggleButton, ToolbarIcon } from '../../styles';

export const ClearFormatting = (props) => {
  const { t } = useTranslation();

  return (
    <ToggleButton title={t('Clear Formatting')} {...props}>
      <ToolbarIcon
        icon="remove-format"
        color="var(--color-background-darker)"
      />
    </ToggleButton>
  );
};
